import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  multiStatusContainer: {
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(1),
    display: 'inline-block',
  },
  select: {
    minWidth: 250,
    marginTop: theme.spacing(1),
    '& .MuiSelect-select': {
      padding: theme.spacing(1.5, 2),
    },
  },
  expandIcon: {
    right: 8,
    position: 'absolute',
    pointerEvents: 'none',
    color: theme.palette.text.secondary,
  },
}));

export default useStyles;
